import { UserStateApiModel } from '../../../api/users/models/user-state.api.model';
import { UserAccountModel } from './user-account.model';
import { AccountModel } from './account.model';
import { AccountApiModel } from '../../../api/accounts/models/account.api.model';
import { SystemNotificationModel } from '../../../Admin/SystemNotifications/models/system-notification.model';

export class UserStateModel extends UserAccountModel {
    impersonator?: UserAccountModel;
    accounts: AccountModel[];
    notifications?: SystemNotificationModel[];

    constructor(apiEntity?: UserStateApiModel, accountEntities?: AccountApiModel[],accountUsersEntity?: UserAccountModel[]) {
        super(apiEntity.currentUserAccount, accountUsersEntity);

        if (apiEntity) {
            this.notifications = apiEntity.notifications ? apiEntity.notifications.map(notification => new SystemNotificationModel(notification)) : [];
            this.impersonator = apiEntity.impersonatorUserAccount ? new UserAccountModel(apiEntity.impersonatorUserAccount) : null;
        }
        if (accountEntities) {
            this.accounts = accountEntities.map(
                accountEntity => new AccountModel(accountEntity)
            );
        } else {
            this.accounts = [];
        }
    }
}
